<i
  class="not-italic leading-none font-normal"
  [ngStyle]="{
    fontFamily: font()
  }"
  [ngClass]="[
    externalSize() ? externalSize() :
    size() === 'small' ? 'text-[16px]' : 
    size() === 'medium' ? 'text-[24px]' : 
    size() === 'large' ? 'text-[32px]' : ''
  ]"
>
  {{ iconContent() }}
</i>
